<template lang="pug">
	section#formulario
		.wrapper
			h1 #[strong BAIXE AGORA] O DOCUMENTO COM TODAS AS #[strong DICAS PARA O]
			img(src="@images/prouniHome/PROUNI.png")
			form(@submit.prevent="sendFormulario")
				.fields
					.field
						span Nome
						input(v-model="form.nome" type="text" placeholder="Insira seu nome")
						span.erro(v-if='errors.nome') {{ errors.nome[0] }}
					.field._50
						span Telefone
						input(v-model="form.telefone" type="tel" placeholder="Insira seu telefone" v-mask="['(##) #####-####', '(##) ####-####']")
						span.erro(v-if='errors.telefone') {{ errors.telefone[0] }}
					.field._50
						span E-mail
						input(v-model="form.email" type="text" placeholder="Insira seu e-mail")
						span.erro(v-if='errors.email') {{ errors.email[0] }}
				button(type="submit" :disabled="disabled")
					span {{ textButton }}
</template>

<script>
import { mask } from 'vue-the-mask'

export default {
	name: "section-formulario",
	directives: {
		mask,
	},
	data() {
		return {
			form: {
				nome: '',
				telefone: '',
				email: ''
			},
			errors: {
				nome: [''],
				telefone: [''],
				email: ['']
			},
			disabled: false,
			textButton: "BAIXE AGORA!"
		}
	},
	methods: {
		sendFormulario() {
			this.disabled = true
			this.errors = {}
			this.textButton = 'Enviando...'
			this.$axios
				.post('lead/prouni-2023', this.form)
				.then(() => {
					this.textButton = 'Enviado!'
					this.form = Object.assign({}, {
						nome: '',
						telefone: '',
						email: ''
					})
					window.open('/base/DOC_PROUNI_2024.pdf', '_blank')
					this.$emit('next')
				})
				.catch(error => {
					console.log(error)
					this.errors = error.response.data.error_validate
					this.textButton = 'Tente novamente'
				})
				.finally(() => {
					setTimeout(() => {
						this.textButton = 'BAIXE AGORA!'
						this.disabled = false
					}, 5000)
				})
		}
	}
}
</script>

<style lang="stylus" scoped src="./Formulario.styl"></style>
